<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="w-100 text-left">
          <icon-megaphone width="40" height="40" class="d-inline-flex mb-4" />
          <p class="header">
            Attention
          </p>
        </div>

        <div class="body">
          {{ text.content }}
          <div class="mt-2 font-weight-bolder">
            {{ text.confirmMessage }}
          </div>
          <div v-if="validationInput">
            <input
              v-model="validationText" class="mt-2 p-1" type="text" placeholder="Je confirme mon opposition"
              :class="validationError ? 'border border-danger' : ''" @keyup.enter="validate()"
            >
          </div>
          <div class="text-right mt-4">
            <button class="modal-cancel-button mr-4 pt-2" @click="$emit('close-modal')">
              Annuler
            </button>
            <button class="modal-default-button ml-2" @click="validate()">
              {{ text.validation }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconMegaphone from "@/assets/icons/IconMegaphone";

export default {
  name: 'PopIn',
  components: {IconMegaphone},
  props: {
    text: {
      type: Object,
      required: true
    },

    validationInput: {
      type: String,
      required: false,
      default: null
    }
  },

  data() {
    return {
      validationText: null,
      validationError: false
    };
  },

  methods: {
    validate() {
      if (!this.validationInput) {
        this.$emit('validation');
      }
      if (this.validationText && this.validationText.toUpperCase() === this.validationInput.toUpperCase()) {
        this.validationError = false;
        this.$emit('validation');
      } else {
        this.validationError = true;
      }
    }
  }
};
</script>

<style scoped>

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 40%;
  height: auto;
  min-height: fit-content;
  margin: 0px auto;
  padding: 40px;
  background: #FFFFFF;
  border: 0.587853px solid #D5D7DE;
  box-shadow: 0px 2.35141px 2.35141px rgba(19, 34, 57, 0.05), 0px 4.70282px 4.70282px rgba(19, 34, 57, 0.05), 0px 9.40564px 9.40564px rgba(19, 34, 57, 0.05);
  border-radius: 8px;
}

.header {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: -0.4px;
}

.body {
  font-weight: 400;
  letter-spacing: -0.176356px;
  color: #686F78;
  font-size: 14px;
}

.modal-default-button {
  color: white;
  float: right;
  background: #F35E5B;
  box-shadow: 0px 1px 3px rgba(19, 34, 57, 0.16);
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 4px;
  border: unset;
}

.modal-cancel-button {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: -0.3px;
  color: #A0A7B0;
  border-radius: 4px;
  border: unset;
  background-color: unset;
}

input {
  background: #FFFFFF;
  border: 1px solid #D5D7DE;
  box-shadow: 0px 1px 2px rgba(19, 34, 57, 0.12), inset 0px 1px 3px rgba(19, 34, 57, 0.08);
  border-radius: 4px;
  width: 349px;
}

.border-danger {
  border: 2px solid #dc3545 !important;
}
</style>
